export const DOCUMENTS_API = (communityId: string) => `v1/community/${communityId}/documents`;
export const DOCUMENTS_API_V2 = (communityId: string) => `v2/community/${communityId}/documents`;